<template>
  <div @click="onClick">
       
       <div class="inline field">
        <label>Email: </label>
        <span>{{rowData.email}}</span>
      </div>
          <div class="inline field">
        <label>Contact Name: </label>
        <span>{{rowData.contactName}}</span>
      </div>
     
      <div class="inline field">
        <label>Contact Phone: </label>
        <span>{{rowData.contactPhone}}</span>
      </div>
      <div class="inline field">
        <label>Communication Mode : </label>
        <span>{{rowData.communicationMode}}</span>
      </div>

      <div class="inline field">
        <label>Security Code : </label>
        <span>{{rowData.securityCode}}</span>
      </div>
      <div class="inline field">
        <label>End Point Url : </label>
        <span>{{rowData.endPointUrl}}</span>
      </div>
    <div class="inline field">
        <label>Active : </label>
        <span>{{rowData.active}}</span>
      </div>
     
      <div class="inline field">
        <label>Received Location : </label>
        <span>{{rowData.receivedLocation}}</span>
      </div>
     
</div>
</template>

<script>
export default {
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    onClick (event) {
            console.log('MemberVendorDetails: on-click', event.target)
    }
  },
}
</script>




// WEBPACK FOOTER //
// src/components/manage-cxml/PartnerDetails.vue